import type React from 'react';
import { Link } from 'react-router-dom';

export const Logo: React.FC = () => {
  return (
    <Link to="/" className="flex items-center gap-x-6">
      <img src="/assets/public/images/logo.webp" alt="logo" width={84} height={30} />
    </Link>
  );
};
